export const GLU_ASSET_TYPE_ID = 3;
export const GLX_ASSET_TYPE_ID = 4;
